<header class="header show-elements" id="header">
	<div class="container header__container clearfix">
		<a class="logo" [routerLink]="[nextLang]" routerLinkActive="active"></a>
		<div class="menu hidden-mobile">
			<menu-header (changeLang)="changeLang($event)"></menu-header>
		</div>
		<div class="mobile-menu" [class.active]="isOpenMobile">
			<menu-header (changeLang)="changeLang($event)" (clickItemMenu)="hideMobileMenu()"></menu-header>
			<div class="close-menu-mobile" (click)="hideMobileMenu()"></div>
		</div>
		<div class="header__right hidden-mobile">
			<ng-container *ngIf="!nextLang.length">
				<div class="lang-btn" (click)="changeLang('en')">EN</div>
			</ng-container>
			<ng-container *ngIf="nextLang.length">
				<div class="lang-btn" (click)="changeLang()">RU</div>
			</ng-container>
		</div>
		<search-header class="header__search" (toggle)="onSearchHeaderToggle($event)"></search-header>
		<div class="mobile-menu-overlay" [class.active]="isOpenMobile" (click)="hideMobileMenu()"></div>
	</div>
	
	<search-block></search-block>

	<filter-works-list
		class="mobile-filter visible-mobile"
		[class.active]="ifActiveFilterWorks"
	></filter-works-list>

	<filter-clients-list
		class="mobile-filter visible-mobile"
		[class.active]="ifActiveFilterClients"></filter-clients-list>
</header>

<div class="mobile-button" (click)="openMobileMenu()">
	<span class="hamburger-menu"></span>
</div>
